<template>
  <div class="" ref="document">
    <div id="element-to-convert" class="p-6 text-neutral-700">
      <div class="flex justify-center mb-4">
        <img src="@/assets/images/logos/Logo-black.svg" class="w-10" />
      </div>
      <div class="block border-b border-neutral-700 border-dashed mb-1"></div>
      <div class="table table-fixed w-full px-4 mb-1 py-4 border-b border-t border-neutral-700 border-dashed">
        <p class="table-cell align-middle text-left">Tanggal:</p>
        <p class="table-cell align-middle text-right">{{ orderDetail.created_time_display }}</p>
      </div>
      <div class="block border-b border-neutral-700 border-dashed"></div>
      <div class="mt-4 px-4 mb-4 text-left">
        <p class="font-semibold">Pengirim</p>
        <p>{{ orderDetail?.order_delivery?.sender?.name }}, {{ orderDetail?.order_delivery?.sender?.phone_number }}</p>
        <p>{{ orderDetail?.order_delivery?.sender?.address }}</p>
      </div>
      <div class="mt-4 px-4 mb-4 text-left">
        <p class="font-semibold">Penerima</p>
        <p>{{ orderDetail?.order_delivery?.receiver?.name }}, {{ orderDetail?.order_delivery?.receiver?.phone_number }}</p>
        <p>{{ orderDetail?.order_delivery?.receiver?.address }}</p>
        <div v-if="orderDetail?.order_delivery?.receiver?.detail_address" class="mt-4">
          <p class="font-semibold">Intruksi Khusus</p>
          <p>{{ orderDetail?.order_delivery?.receiver?.detail_address }}</p>
        </div>
      </div>
      <div class="mt-4 px-4 mb-1 text-left border-b pb-4 border-neutral-700 border-dashed">
        <p class="font-semibold">Produk</p>
        <div class="flex justify-start mb-4 last:mb-0" v-for="(packageItem, index) in orderDetail?.order_delivery?.packages" :key="'package-' + index">
          <p>{{ packageItem.category }}</p>
        </div>
      </div>
      <div class="block border-b border-neutral-700 border-dashed"></div>
      <div class="mt-4 px-4 mb-10 text-left">
        <div class="flex justify-between items-center mb-2">
          <p>Pembayaran:</p>
          <p>{{ orderDetail?.payment_info?.payment_method }}</p>
        </div>
        <div class="flex justify-between items-center ">
          <p>Biaya:</p>
          <p>{{ orderDetail?.payment_info?.price | currencyFormat }}</p>
        </div>
      </div>
      <p class="text-2xl font-bold text-center">Thank You</p>
    </div>
    <div class="flex justify-center mt-4">
      <Button buttonText="Download Receipt" size="small" @action="download()" />
    </div>
  </div>
</template>
<script>
import html2pdf from 'html2pdf.js'
import { currencyFormat } from '@/util'
import { mapActions } from 'vuex'
export default {
  filters: {
    currencyFormat
  },
  components: {
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button')
  },
  props: ['orderDetail'],
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    download() {
      this.showLoading()
      html2pdf()
        .set({
          margin: 1,
          filename: `Order Receipt - ${this.orderDetail.order_id}.pdf`
        })
        .from(document.getElementById('element-to-convert'))
        .save()
        .then(() => {
          this.hideLoading()
          this.$emit('close')
        })
    }
  }
}
</script>
